import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Auto-reload on stale chunk errors (after deploy)
const isChunkError = (msg: string) =>
  msg?.includes("Failed to fetch dynamically imported module") ||
  msg?.includes("Importing a module script failed");

window.addEventListener("error", (e) => {
  if (isChunkError(e.message)) window.location.reload();
});

window.addEventListener("unhandledrejection", (e) => {
  const msg = e.reason?.message ?? String(e.reason ?? "");
  if (isChunkError(msg)) window.location.reload();
});

const removeSplash = () => {
  const splash = document.getElementById("splash");
  if (splash) {
    splash.style.opacity = "0";
    setTimeout(() => splash.remove(), 300);
  }
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

requestAnimationFrame(() => requestAnimationFrame(removeSplash));
